<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-paste"></i>
        서버 정보
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">webcastle</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">서버</a>
        </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <b-card v-else>
      <div class="d-flex flex-wrap align-items-center">
        <div class="title mr-auto mb7" v-if="server && server.url">
          <!-- <i class='fa fa-align-justify' v-if="server && server.url"></i> -->
          <!-- detailAgent api 호출 (get) -->
          <b-form-select v-model="server.id" v-on:change="change_target($event, server)" size="sm" style="max-width: 20rem;" v-if="agent_list && agent_list.length">
            <option v-for="item in agent_list" :key="item.id" :value="item.id">{{item.url}}</option>
          </b-form-select>
          <span v-else>에이전트 정보</span>
        </div>
        <div class="mb7">
          <strong class="pull-right">설치 날짜 : {{server.created_at | sdate}}</strong>
        </div>
      </div>
      <hr>
      <!-- TODO : quickSetup 07 ver 이전 이후로 나눠져야함.-->
      <template v-if="quick_setting_status" class="animated fadeIn fadeOut">
        <RuleQuickSetup
          v-if="default_rule && default_rule.rule"
          :rule_selected="sel_domain.rule"
          :domain="sel_domain.domain"
          :quick_setting="quick_setting"
          :ico="ico"
          :is_one="is_one"
          :crs_rule="default_rule.rule"
          :setting_level="setting.level"
          :setting_mode="setting.mode"
          :user="user"
          :is_first="is_first"

          @save_default="save_default"
          @status="() => { quick_setting_status = false; is_first = false }"
          @quick_setting_update="(data) => { quick_setting = Object.assign({}, quick_setting, data) }"
        >
        </RuleQuickSetup>
      </template>
      <template v-if="server && !quick_setting_status">
        <b-row class="row mb-2" v-if="server && !quick_setting_status">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="" style="letter-spacing:-1px;">
              WEBCastle 엔진 (글로벌) On / Off
            </label>
          </b-col>
          <b-col class="col-xl-8 col-md-12  d-flex align-self-center">
            <div class="checkbox-switch">
              <!-- on/off 시 update api 호출 -->
              <input type="checkbox" class="input-checkbox" name="switch01" id="switch01" :disabled="server.is_del" v-model="setting.status" v-on:change="status_save($event, setting.status)" switch>
              <div class="checkbox-animate">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center flex-row-reverse">
            <button type="button" class="btn btn-sm btn-insert" tabindex="4" @click="quick_setting_status = true" :disabled="server.is_del ? lock : setting_lock">
              빠른 설정
            </button>
          </b-col>
        </b-row>
        <b-card v-if="server && !quick_setting_status">
          <b-row class="mb-2" v-if="server.os_type">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="" style="cursor: pointer;" @click="modal_name = true">
                이름
                <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <span @click="server.is_del ? nickname_modify_modal : nickname_modify_modal = true" style="cursor: pointer; color: skyblue;">{{ server.nickname }}</span>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="">
                IP
              </label>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              {{server.ip_addr || '-'}}
            </b-col>
          </b-row>
          <b-row class="mb-2" v-if="server.os_type">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="">
                OS
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              {{server.os_type  || '-'}}
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="">
                버전
              </label>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              {{server.version  || '-'}}
            </b-col>
            <!-- Todo : online / offline 상태를 보여주어야함
            <b-col sm="2">
              Status
              <br>
              <b-badge variant="success" v-if="info.ms">Online</b-badge>
              <b-badge v-else variant="secondary">Offline</b-badge>
            </b-col> -->
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" style="cursor: pointer;">
              <label class="col-form-label" for="" @click="explain_user_crs = true">
                가상 도메인 선택
                <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 mt-3">
              <b-form-select class="form-control" v-model="sel_domain.domain" @change="change_domain($event, sel_domain.id)" size="sm" style="max-width: 20rem;" :disabled="server.is_del ? lock : lock = false">
                <option v-for="item in server.policy_json.domains" :key="item.id" :value="item.domain">{{item.domain}}</option>
              </b-form-select>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" style="cursor: pointer;">
              <label class="col-form-label" for="" style="cursor: pointer;" @click="explain_level = true">
                정책 보안 수준
                <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 mt-4">
              <b-form-radio-group style="cursor: pointer;" id="ph_level" v-model="setting.level" :options="codes.WAF_LEVEL" :disabled="server.is_del ? lock : setting_lock"></b-form-radio-group>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" style="cursor: pointer;">
              <label class="col-form-label" for="" @click="explain_mode = true">
                방화벽 모드
                <span class="font_14 text-info" style="cursor: pointer;"><i class="fas fa-question-circle" @click="explain_mode = true"></i></span>
                <!-- <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span> :
                <b-badge v-if="setting.mode == 0" variant="secondary">Off</b-badge>
                <b-badge v-if="setting.mode == 1" variant="warning">탐지</b-badge>
                <b-badge v-if="setting.mode == 2" variant="danger">차단</b-badge> -->
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 mt-4">
              <b-form-radio-group id="ph_mode" v-model="setting.mode" :options="codes.WAF_MODE_OPTION_KOR" :disabled="server.is_del ? lock : setting_lock"></b-form-radio-group>
            </b-col>
            <b-col class="col-xl-6 col-md-12 d-flex align-self-center flex-row-reverse">
              <div class="pull-right">
                <!-- <b-button block size="sm" class="mb-2" variant="success" @click="rule_confirm = true">Apply</b-button> -->
                <!-- <b-button block size="sm" class="mb-2" variant="warning" @click="apply_modal = true">Apply to other servers</b-button> -->
                <b-button block size="sm" class="mb-2" variant="add" @click="explain_user_crs = true">도메인 관리</b-button>
                <b-button block size="sm" class="mb-2" variant="danger" v-if="server.is_alive" @click="modal_del = true; del_info = server">삭제</b-button>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-5">
            <b-col class="col-xl-12 col-md-12 text-warning">
              <!-- 이름 변경을 위한 모달을 제외하고는 전부 update api 를 부르지않음 -->
              <b-button v-if="server.is_del" class="float-left" size="sm" variant="warning" :disabled="lock">정보가 삭제되었어요.</b-button>
              <b-button class="float-right" size="sm" variant="primary" @click="list()">목록</b-button>
            </b-col>
          </b-row>
        </b-card>
        <!-- 탭부분 시작 -->
        <b-tabs v-model="tabIndex" v-if="server && !quick_setting_status">
          <!-- 방화벽 기본 정책 설정 -->
          <b-tab style="cursor: pointer;" title="정책 (CRS)">
            <b-row>
              <b-col>
                <strong class="text-danger">* 방화벽 정책을 설정할 수 있어요. ( 활성화 또는 비활성화만 가능해요 )</strong>
                <!-- 1. Quick은 사용하는 서비스 선택, (기본 설정들 보여줌) -->
                <!-- 2. allow ip 선택 -->
                <!-- <span class="pull-right">Version : <strong >{{ default_rule.version }}</strong></span> -->
                <!-- 변경시 update api 호출 -->
                <b-form-select class="float-right ml-2" v-model="target_crs_rule" @change="() => change_main_policy = true" size="sm" style="max-width: 10rem;" :disabled="server.is_del ? lock : lock = false">
                  <option  v-for="(item, index) in crs_version_list" :key="index" :value="item">{{item.version}}</option>
                </b-form-select>
                <Bell style="float:right; margin-top:5px;" :size="20" :count="crs_rule_count" v-if="get_max_policy()" />
              </b-col>
            </b-row>
            <hr>
            <RuleService
              v-if="!quick_setting_status"
              :quick_setting="quick_setting"
              :ico="ico"
              @toggle_policy="toggle_policy"
              :service_lock = "server.is_del ? lock : lock = false"
            ></RuleService>
            <hr v-if="!quick_setting_status" class="animated fadeIn fadeOut">
            <template v-if="!quick_setting_status" class="animated fadeIn fadeOut">
              <RuleSelector
                v-if="sel_domain"
                class="table table_add"
                ref="RuleSelector"

                :rule_selected="sel_domain.rule"
                :rule_data="rule_set.rule"
                :rule_block="sel_domain.block"
                :rule_detect="sel_domain.detect"
                :mode="setting.mode"
                :level="setting.level"
                :rule_lock="server.is_del ? lock : lock = false"

                @policy_rule="policy_rule"
                @quick_policy_one="(data) => quick_setting = Object.assign({}, quick_setting, data)"
                @block_policy="(block) => sel_domain = Object.assign({}, sel_domain, { block : block })"
                @detect_policy="(detect) => sel_domain = Object.assign({}, sel_domain, { detect : detect })"
                @rule_sel="(x) => sel_domain = Object.assign({}, sel_domain, { rule : x })"
                v-bind:toss_rule="save"
              />
            </template>
          </b-tab>
          <!-- 방화벽 사용자 설정 -->
          <!-- custom 문법 체크가 필요함 -->
          <b-tab style="cursor: pointer;" title="정책 사용자 설정 (Custom-CRS)">
            <b-row>
              <b-col class="col-xl-12 col-md-12 d-flex align-self-center">
                <span class="">
                  <strong>사용자 맞춤 CRS 설정</strong>
                  <br>
                  <b-badge variant="warning">안내</b-badge> 전문가만 설정하는것을 권해요.
                </span>
              </b-col>
            </b-row>
            <b-row class="mt-5">
              <b-col class="col-xl-6 col-md-12 d-flex align-self-center">
                <span class="">
                  사용자가 규칙을 정의할 수 있어요.
                  <br><br>
                  Rule ID 2000000~+ ID를 지정해주세요.
                </span>
              </b-col>
              <b-col class="col-xl-6 col-md-12 d-flex align-self-center">
                <span class="">
                  호스트 헤더가 IP 주소로 요청될 때, 탐지되는 Rule 은 920350 이에요.
                  <br><br>
                  예시: SecRuleUpdateActionById 920350 "t:none,msg:'네트워크 공격',허용"
                </span>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col class="col-xl-6 col-md-12 align-self-center">
                <b-form-group>
                  <b-form-input placeholder="Example) http://f1security.co.kr/warning.html" v-model="using_redir" @change="redir_change" :disabled="server.is_del ? lock : lock = false"></b-form-input>
                  <br>
                  <b-form-checkbox v-model="is_redir" @change="x => using_redir = x ? using_redir : ''" :disabled="server.is_del ? lock : lock = false">
                    <p class="text-danger text-bold">차단 모드에서 탐지를 위한 리디렉션 제공</p>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col class="col-xl-6 col-md-12 align-self-center">
                <b-form-group>
                  <b-form-textarea id="ph_content" v-model="user.custom_rule" :rows="line_count()" :max-rows="80" :disabled="server.is_del ? lock : lock = false"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <!-- ip 관련 접근 제어 -->
          <b-tab style="cursor: pointer;" title="IP 주소">
            <RuleIP
              class="animated fadeIn fadeOut"
              @block_ip="($val, key) => user.block_ip = $val"
              @allow_ip="($val, key) => user.allow_ip = $val"
              :origin="{ allow_ip : user.allow_ip, block_ip: user.block_ip }"
              :is_setup="false"
              :setting="{ 모드: server.mode, 수준 : setting.level }"
              :ip_lock = "server.is_del ? lock : lock = false"
            ></RuleIP>
          </b-tab>
          <b-tab style="cursor: pointer;" title="경로 및 파라미터(Query String)">
            <b-row>
              <b-col>
                <!-- @update 에서 key 는 구분자임 -->
                <!-- path 관련 사용자 정책 설정 -->
                <RuleCustom
                  class="animated fadeIn fadeOut"
                  :origin="user.path"
                  name="path"
                  :is_setup="false"
                  example="/admin,/manager"
                  @update="($val, key) => user.path = $val"
                  :custom_lock = "server.is_del ? lock : false"
                ></RuleCustom>
              </b-col>
              <b-col>
                <!-- 파라미터 관련 사용자 설정 -->
                <!-- @update 에서 key 는 구분자임 -->
                <RuleCustom
                  class="animated fadeIn fadeOut"
                  :origin="user.parameter"
                  name="params"
                  example="id=test : Detects if query string has id=test,test : Detects if query string has test"
                  :is_setup="false"
                  @update="($val, key) => user.parameter = $val"
                  :custom_lock = "server.is_del ? lock : false"
                ></RuleCustom>
              </b-col>
            </b-row>
          </b-tab>
          <!-- CUSTOM country code -->
          <b-tab style="cursor: pointer;" title="국가">
            <RuleCountry
              ref="_country"
              class="animated fadeIn fadeOut"
              :origin="user.country_code"
              :origin_use_geoip="user.use_geoip"
              :country_lock = "server.is_del ? lock : false"

              name="country_code"
              @update="($val, key) => user.country_code = $val"
              @use_geoip="($val, key) => user.use_geoip = $val"
            />
          </b-tab>
          <b-tab style="cursor: pointer;" title="메소드 제어">
            <!-- :origin_use_geoip => :origin_use_method 로 변경
                  RuleMethod 에서는 :origin_use_geoip 가 없음 -->
            <RuleMethod
              ref="_method"
              class="animated fadeIn fadeOut"
              :origin="user.method_control"
              :origin_use_method="user.use_method"
              :method_lock = "server.is_del ? lock : lock = false"

              name="method"
              @update="($val, key) => user.method_control = $val"
              @use_method="($val, key) => user = Object.assign({}, user, { use_method : $val })"
            />
          </b-tab>
          <b-tab style="cursor: pointer;" title="로그" @click="refresh()">
            <b-row>
              <b-col>
                <strong>서버에 대한 탐지/차단 로그를 표시해요.</strong><br><br>
                <span>* 최근 로그 50개만 보여주고있어요.</span><br>
                <span v-if="th" class="float-right">
                  <i class="fa fa-refresh fa-spin"></i>
                  실시간 업데이트
                </span>
                <br><br>
                <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="관련된 정보가 없어요."
                  :items="getItems" :fields="fields" :current-page="currentPage" :per-page="50">
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>로딩 중...</strong>
                    </div>
                  </template>
                  <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
                  <template slot="created_at" slot-scope="row">{{ row.item.created_at| sdate }}</template>
                  <template slot="remote_addr" slot-scope="row">
                    {{row.item.remote_addr}}
                    <CountryFlag v-if="row.item.country" class="explain" :country="row.item.country" size='small'/>
                  </template>
                  <template slot="is_block" slot-scope="row">
                    <b-badge v-if="row.item.is_block && row.item.block_cnt > 0" variant="danger">차단</b-badge>
                    <b-badge v-else variant="warning">탐지</b-badge>
                  </template>
                  <template slot="message" slot-scope="row">
                    <strong @click="log_view(row.item)">
                      {{ruleI18n[row.item.message.details.ruleId] ? ruleI18n[row.item.message.details.ruleId]['KOR'] : row.item.message.message }}
                    </strong>
                  </template>
                  <template slot="ruleid" slot-scope="row">
                    {{row.item.message ? row.item.message.details.ruleId : row.item.m_id }}
                  </template>
                  <template slot="severity" slot-scope="row">
                    <span scope="row" v-if="row.item.message.details.severity == 0"><b-badge variant="danger">비상</b-badge></span>
                    <span scope="row" v-else-if="row.item.message.details.severity == 1"><b-badge variant="danger">알림</b-badge></span>
                    <span scope="row" v-else-if="row.item.message.details.severity == 2"><b-badge variant="danger">위험</b-badge></span>
                    <span scope="row" v-else-if="row.item.message.details.severity == 3"><b-badge variant="warning">에러</b-badge></span>
                    <span scope="row" v-else-if="row.item.message.details.severity == 4"><b-badge variant="warning">경고</b-badge></span>
                    <span scope="row" v-else-if="row.item.message.details.severity == 5"><b-badge variant="info">주의</b-badge></span>
                    <span scope="row" v-else-if="row.item.message.details.severity == 6"><b-badge variant="info">안내</b-badge></span>
                    <span scope="row" v-else><b-badge variant="dark">인식되지않음</b-badge></span>
                  </template>
                  <template slot="uri" slot-scope="row">
                    {{row.item.uri | truncate(50) }}
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab style="cursor: pointer;" title="모니터링">
            <!-- info : {{info.ms}} -->
            <b-row v-if="info.ms">
              <b-col class="rounded-lg pt-2 m-2" sm="2">
                <vue-speedometer
                    class="fadeIn fadeOut animated"
                    v-if="info.status && info.status.system_memory_info"
                    style="display:inline-block; height:90px; float:left;"
                    :width="100"
                    :height="100"
                    :needleHeightRatio="0.4"
                    :value="ramStatus"
                    :customSegmentStops='[0, 250, 750, 1000]'
                    :segmentColors='["#22dc6d", "#ffc90e", "#ed1c24"]'
                    :currentValueText="`RAM(${ramStatus} %)`"
                    :customSegmentLabels='[ { text: "L", position: "INSIDE", color: "#fff", }, { text: "N", position: "INSIDE", color: "#fff", }, { text: "H", position: "INSIDE", color: "#fff", }, ]'
                    :ringWidth="18"
                    :needleTransitionDuration="1000"
                    needleTransition="easeElastic"
                    needleColor="#a7ff83"
                    textColor="#000"
                  />
                  <br>
                  <vue-speedometer
                  class="fadeIn fadeOut animated"
                  v-if="info.status && info.status.system_cpu_info"
                  style="display:inline-block; height:90px; float:left;"
                  :width="100"
                  :height="100"
                  :needleHeightRatio="0.4"
                  :value="cpuStatus"
                  :customSegmentStops='[0, 250, 750, 1000]'
                  :segmentColors='["#22dc6d", "#ffc90e", "#ed1c24"]'
                  :currentValueText="`CPU(${cpuStatus / 10 } %)`"
                  :customSegmentLabels='[ { text: "L", position: "INSIDE", color: "#fff", }, { text: "N", position: "INSIDE", color: "#fff", }, { text: "H", position: "INSIDE", color: "#fff", }, ]'
                  :ringWidth="18"
                  :needleTransitionDuration="1000"
                  needleTransition="easeElastic"
                  needleColor="#a7ff83"
                  textColor="#000"
                />
              </b-col>
              <b-col class="rounded-lg pt-2 m-2">
                <folderSet  :disk_list="disckStatus"/>
              </b-col>
            </b-row>
            <!-- <b-row v-else>
              <b-col class="col-xl-12 col-md-12 align-self-center mt-3 text-center">
                <strong class="title">에이전트가 오프라인 상태이에요</strong>
              </b-col>
            </b-row> -->
            <b-row>
              <b-col class="col-xl-12 col-md-12 align-self-center text-center">
                <b-form-group>
                  <div class="checkbox-switch float-right mr-3">
                    <input type="checkbox" class="input-checkbox" name="switch06" id="switch06" color="success" label variant="pill" v-model="setting.limit_mode" :disabled="server.is_del ? lock : setting_lock">
                    <div class="checkbox-animate disabled">
                      <span class="checkbox-off">OFF</span>
                      <span class="checkbox-on">ON</span>
                    </div>
                  </div>
                </b-form-group>
                <p style="display:inline-block; cursor: pointer;" @click="server.is_del ? lock : (setting_lock ? setting_lock : (setting.limit_mode = !setting.limit_mode))"> <span class="mr-3">Resource Monitoring 경고 설정</span> <i v-if="setting.limit_mode" class="fa fa-refresh fa-spin"></i></p>
                <br>
                <small class="text-danger">
                  시스템 리소스가 임계값을 초과하면 알림이 한 번 생성돼요.
                  <br>
                  기준이 정상일 때 통보할 수 있어요.
                  <br>
                  ( 90% 임계값과 60% 정상 표준을 권장합니다. )
                </small>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col sm="2" class="mt-2">CPU 임계값(90%)</b-col>
              <b-col sm="2">
                <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="setting.limit_cpu" :disabled="server.is_del ? lock : setting_lock"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">RAM 임계값(90%)</b-col>
              <b-col sm="2">
                <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="setting.limit_ram" :disabled="server.is_del ? lock : setting_lock"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">Disk 임계값(90%)</b-col>
              <b-col sm="2">
                <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="setting.limit_disk" :disabled="server.is_del ? lock : setting_lock"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row>
              <!-- 여기서 라인 나눔 -->
              <b-col sm="2" class="mt-2">CPU 정상(60%)</b-col>
              <b-col sm="2">
                <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="setting.resolve_cpu" :disabled="server.is_del ? lock : setting_lock"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">RAM 정상(60%)</b-col>
              <b-col sm="2">
                <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="setting.resolve_ram" :disabled="server.is_del ? lock : setting_lock"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">Disk 정상(60%)</b-col>
              <b-col sm="2">
                <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="setting.resolve_disk" :disabled="server.is_del ? lock : setting_lock"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </template>
      <template v-else>
        <b-card>
          <div class="text-center">
            <span class="font-weight-bold">관련 정보가 없어요.</span>
          </div>
        </b-card>
      </template>
    </b-card>
    <!-- for modal -->
    <b-modal title="Status Save?"  class="modal-warning" v-model="status_confirm" @ok="status_save" ok-variant="danger">
      <p>해당 서버에서 방화벽을 끄거나 켭니다.</p>
    </b-modal>
    <b-modal title="Rule Save?"  class="modal-warning" v-model="rule_confirm" @ok="save" ok-variant="danger" header-bg-variant="danger">
      <p>변경된 설정 저장 잘못된 규칙 설정은 서비스에 영향을 미칠 수 있습니다.</p>
    </b-modal>
    <!-- 레벨 설명 모달 -->
    <b-modal title="[레벨 범위] 보안 정책 수준"  class="modal-info text-center" v-model="explain_level" ok-only no-close-on-backdrop ok-variant="outline-primary" ok-title="확인">
      <div class="text-center">
        <img src="img/waf_level.png" class="text-center" style="margin-left: auto; margin-right: auto; width: 90%;">
        <p class="text-danger mt-3" style="font-weight:bold;">
          레벨이 높을수록 더 많은 공격을 탐지해요.<br>
          레벨 설정 후, 상세 정책 설정을 권해요.<br>
        </p>
      </div>
      <div class="mt-3">
        Level 4 는 정책 레벨 1 ~ 4 로 탐지해요.<br>
        Level 3 는 정책 레벨 1 ~ 3 로 탐지해요.<br>
        Level 2 는 정책 레벨 1 ~ 2 로 탐지해요.<br>
        Level 1 은 정책 레벨 1 로 탐지해요.<br>
      </div>
    </b-modal>

    <!-- 다른 서버 적용 모달 -->
    <b-modal hide-footer title="정책을 적용할 에이전트" size="xl" v-model="apply_modal" header-bg-variant='warning'>
      <!-- <b-button size="sm" variant="primary" @click="() => { policy_list = server.policy_json.domains.map(r => r.domain) }"> Select All </b-button> -->
      <b-button size="sm" variant="warning" @click="policy_list = []"> 초기화 </b-button>
      <hr>
      <p class="m-2">
        <b-form-checkbox-group class="m-2"  v-model="policy_list">
          <b-form-checkbox v-for="policy in server.policy_json.domains" :key="policy.id"  :value="policy.domain">
            {{policy.domain}}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </p>
      <hr v-if="apply_all_server && apply_all_server.length > 0">
      <b-badge variant="success" v-for="(item, index) in apply_all_server" :key="index" class="m-1">
        <h6 @click="multi_remove(index)" style="cursor:pointer;">{{item.nickname}} <span class="m-1" style="cursor:pointer;">X</span></h6>
      </b-badge>
      <hr>
      <agent-List :agent_id="server.id" :list_selected="apply_all_server"  :only_select="true" @multi_clear="multi_clear" @multi_all="multi_all" @multi_one="multi_one"></agent-List>
      <hr>
      <b-button block variant="warning" @click="apply_confirm_modal = true" class="m-1">적용</b-button>
      <b-button block variant="info" @click="apply_modal = false" class="m-1">닫기</b-button>
    </b-modal>
    <!-- 다른 서버 적용 모달 다시 확인 -->
    <!-- <b-modal hide-footer title="정책 적용 확인" size="xm" v-model="apply_confirm_modal" header-bg-variant='danger'>
      선택한 에이전트에 설정을 적용하시겠습니까?
      <hr>
      <b-button block variant="danger" @click="multi_save" class="m-1">적용</b-button>
      <b-button block variant="info" @click="apply_confirm_modal = false" class="m-1">닫기</b-button>
    </b-modal> -->
    <!-- 방화벽 운영 모드 관련 안내 모달 -->
    <b-modal title="도메인 관리" class="modal-info" size="xl" v-model="explain_user_crs" no-close-on-backdrop ok-only @ok="explain_user_crs = false" ok-title="확인" ok-variant="outline-primary">
      <b-table ref="_list" striped hover small fixed class="table-responsive-sm" :items="server && server.policy_json && server.policy_json.domains" :fields="domain_manage_fields" empty-text="관련된 정보가 없어요.">
        <template slot="domain" slot-scope="row">
          <b-form-input @change="change_policy_name" :disabled="('default' == row.item.domain && row.index == 0) || !row.item.temp" class="pull-right m-1" size="sm" v-model="row.item.domain"></b-form-input>
        </template>
        <template slot="status" slot-scope="row">
          <b-badge v-if="row.item.temp" variant="danger">저장되지않음</b-badge>
          <b-badge v-else variant="success">사용됨</b-badge>
          <span v-if="row.item.domain == sel_domain.domain">*</span>
        </template>
        <template slot="mode" slot-scope="row">
          <b-badge v-if="row.item.mode == codes.WAF_MODE_OFF.VALUE || row.item.mode == codes.WAF_MODE_OFF.TEXT" variant="secondary">Off</b-badge>
          <b-badge v-if="row.item.mode == codes.WAF_MODE_DETECTIONONLY.VALUE || row.item.mode == codes.WAF_MODE_DETECTIONONLY.TEXT" variant="warning">탐지</b-badge>
          <b-badge v-if="row.item.mode == codes.WAF_MODE_ON.VALUE || row.item.mode == codes.WAF_MODE_ON.TEXT" variant="danger">차단</b-badge>
        </template>
        <template slot="level" slot-scope="row">{{row.item.level}}</template>
        <!-- <template slot="button" slot-scope="row">
          <b-button size="sm" :disabled="row.item.temp" variant="outline-warning" @click="domain_manage_regist(row.item.domain, `${row.item.domain}.${(new Date()).getTime()}`)">Clone</b-button>
          <b-button v-if="row.item.domain != 'default'" size="sm" variant="outline-danger" @click="domain_direct_remove(row.item)">Remove!</b-button>
        </template> -->
      </b-table>
      <!-- <p>
        <span class="float-left font-weight-bold text-danger">When charging, subdomains will be charged to one domain.</span>
        <b-button class="pull-right m-1" size="sm" variant="success" @click="domain_manage_regist()">Add</b-button>
        <b-form-input class="pull-right m-1" size="sm" v-model="domain" @keyup.native.enter="domain_manage_regist()" placeholder="Domain Add Enter" style="max-width: 20rem;"></b-form-input>
      </p> -->
    </b-modal>
    <!-- Deletion does not work.
    <b-modal title="도메인 삭제" class="modal-danger" v-model="explain_user_domain" no-close-on-backdrop @ok="domain_manage_remove()" header-bg-variant="danger">
      삭제하시겠습니까?
    </b-modal>  -->
    <!-- 모드 설명 모달 -->
    <b-modal title="모드 설명"  class="modal-info text-center" v-model="explain_mode" ok-only no-close-on-backdrop ok-variant="outline-primary" ok-title="확인">
      <b-badge variant="warning">공지</b-badge>
      <br>
      <strong> 정책 보안 수준은 기본적으로 1로 설정되며 더 높은 수준은 서비스에 영향을 미칠 수 있습니다. </strong><br>
      <hr>
      <strong> * 미사용 : 현재 선택된 도메인에 대한 WEBCastle 기능 비활성화</strong><br>
      <strong> * 탐지 : 활성화 중에만 감지 </strong><br>
      <strong> * 차단 : 활성화 중 차단 </strong><br>
      <!-- <strong> * Multiplexing : Managed by a multiplexed firewall policy </strong> -->
      <hr>
      <p class="text-center">
        <b-img v-bind="{ width: 300, height: 300, class: 'm1' }" src="img/multi.png" alt="Multiplexing"></b-img>
      </p>
    </b-modal>

    <!-- 모드 설명 모달 -->
    <b-modal title="정책 메인 버전 변경"  class="modal-warning text-center" v-model="change_main_policy" no-close-on-backdrop ok-variant="success" hide-footer>
      <b-badge variant="warning">공지</b-badge>
      <strong> 방화벽 정책 변경 </strong>
      <hr>
      <p>정책 버전 [ {{crs_rule.version}} ] => <span class="font-weight-bold text-danger">[ {{target_crs_rule.version}} ]</span> </p>
      <hr>
      <p>최소 에이전트 버전 [ {{crs_rule.agent_version ? crs_rule.agent_version : '-'}} ] => <span class="font-weight-bold text-danger">[ {{target_crs_rule.agent_version ? target_crs_rule.agent_version : '-'}} ]</span> </p>
      <hr>
      <p class="text-danger">* 기본 정책을 변경하여 페이지를 새로 고칩니다.</p>
      <hr>
      <small class="font-weight-bold">* 정책 변경 후 문제가 발생하면 정책을 다시 복원할 수 있습니다.</small>
      <hr>
      <div class="modal-footer">
        <b-button block class="btn btn-success" @click="change_crs">업데이트</b-button>
        <b-button block class="btn btn-light" @click="change_main_policy = false; target_crs_rule = crs_rule;">취소</b-button>
      </div>
    </b-modal>

    <!-- 이름 변경 모달 -->
    <b-modal title="서버 이름 변경" class="modal-warning text-center" v-model="nickname_modify_modal" no-close-on-backdrop ok-variant="outline-primary" 
    @ok="nickname_modify()" ok-title="확인" @cancel="nickname_modify_modal = false" cancel-variant="outline-dark" cancel-title="취소">
      <p> 기본 이름은 호스트 이름으로 설정되어있어요. </p>
      <p> <b> * 서버 이름 확인하기 </b> </p>
      <p> 현재 서버 이름 : {{server.nickname}} </p>
      <b-form-input v-model="modify_nickname" placeholder="변경할 서버 이름을 입력하세요."></b-form-input>
    </b-modal>

    <!-- 이름 변경 모달 -->
    <b-modal title="이름 설정" class="modal-warning text-center" v-model="modal_name" no-close-on-backdrop ok-only ok-variant="outline-primary" ok-title="확인">
      <p> 서버 호스트 이름과 다르게 설정할 수 있어요. </p>
    </b-modal>

    <!-- 로그 상세 모달 -->
    <b-modal title="로그 상세" size="xl" class="modal-warning text-center" v-model="modal_log" no-close-on-backdrop ok-variant="success" hide-footer>
      <LogDetail :id="modal_log_id" />
    </b-modal>

    <!-- 삭제 모달 -->
    <b-modal class="modal-dialog modal-dialog-centered modal-danger" title="정보 삭제" v-model="modal_del" @ok="remove" 
    @cancel="del_nickname = '';" header-bg-variant="danger" ok-variant="outline-danger" ok-title="확인" cancel-title="취소" cancel-variant="outline-dark">
      <p> 이곳에서 에이전트를 삭제해도 서버에서는 자동삭제되지 않습니다. 먼저 서버에서 삭제할 것을 권장드립니다. </p>
      <p> 삭제된 경우 방화벽 역할을 수행하지 않습니다.  </p>
      <p> <b> * 서버 이름 확인 </b> </p>
      <p> 삭제할 서버이름 확인 : {{del_info.nickname}}  </p>
      <b-form-input v-model="del_nickname" placeholder="등록 취소할 서버의 이름을 입력합니다."></b-form-input>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
